(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 50881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(92266);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _src_components_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83331);
/* harmony import */ var _src_components_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62084);
/* harmony import */ var _src_components_DynamicPageBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29733);
/* harmony import */ var _utils_CitiesContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8851);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_gtmEvents__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38077);








const Slug = (data)=>{
    const { meta , blocks , cities , canonicalUrl  } = data;
    const { isReady , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    const { update  } = (0,_utils_CitiesContext__WEBPACK_IMPORTED_MODULE_5__/* .useCitiesState */ .$)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        update(cities);
    }, [
        cities
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isReady) {
            (0,_utils_gtmEvents__WEBPACK_IMPORTED_MODULE_7__/* .optimizeActivateEvent */ .wx)();
        }
    }, [
        asPath
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_seo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                description: meta.description,
                title: meta.title,
                picture: meta.picture,
                canonicalUrl: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_DynamicPageBuilder__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                blocks: blocks
            })
        ]
    });
};
Slug.getLayout = function getLayout(data, component) {
    const { routes , topBars , slugs , companyData , hostUrl  } = data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        routes: routes,
        topBars: topBars,
        slugs: slugs,
        companyData: companyData,
        hostUrl: hostUrl,
        children: component
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Slug);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,9466,2084,7385,9774,2888,179], function() { return __webpack_exec__(50881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);